import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {TranslationService} from '@spartacus/core';

import {AimoCart, AimoOrderEntry} from '../../../model/cart.model';
import {AimoProduct} from '../../../model/product.model';
import {AimoActiveCartService} from '../../../service/cart/aimo-active-cart.service';
import {AimoGTMProductAttributes} from '../../../service/gtm/aimo-gtm.model';
import {AimoProductModalService} from '../../../service/product/aimo-product-modal.service';
import {AimoProductService} from '../../../service/product/aimo-product.service';
import {AimoCurrentProductService} from "../../../service/product/aimo-current-product.service";
import {Observable} from "rxjs";
import {AimoAssortmentService, LabelSuffix} from "../../../service/product/aimo-assortment.service";

@Component({
    selector: 'aimo-order-history-order-entry',
    templateUrl: './aimo-order-history-order-entry.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AimoOrderHistoryOrderEntryComponent {
    @Input() order: AimoCart;
    @Input() entry: AimoOrderEntry;
    @Input() isOrderHistory = false;
    @Input() gtmAttributes: AimoGTMProductAttributes;
    myAssortmentLabelSuffix$: Observable<LabelSuffix>;

    constructor(
        protected currentProductService: AimoCurrentProductService,
        protected productService: AimoProductService,
        protected activeCartService: AimoActiveCartService,
        protected translation: TranslationService,
        protected productModalService: AimoProductModalService,
        protected assortmentService: AimoAssortmentService,
    ) {
        this.myAssortmentLabelSuffix$ = this.assortmentService.getMyAssortmentLabelSuffix();
    }

    openProductModal(sourceId: string, product: AimoProduct): void {
        this.productModalService.openProductModal(
            this.entry.product.code,
            this.gtmAttributes,
            null,
            null,
            null,
            sourceId,
        );
    }

    downloadDeliveryNote(invoiceId: string, name: string): void {
        this.translation
            .translate(name, { id: invoiceId })
            .subscribe((t) => this.activeCartService.downloadOrderDocument(invoiceId, t, true))
            .unsubscribe();
    }
}
